import Base from './base'
import { Sentiment } from '../types/sentiments'

export default class Sentiments extends Base {
  async get(): Promise<Sentiment[]> {
    return this.api.get('/sentiments')
  }
}
